document.addEventListener( 'DOMContentLoaded', function() {
	'use strict';

	if ( 'undefined' !== typeof Tablesaw && Tablesaw.init ) {
		Tablesaw.init();
	}

} );
